<div class="sidebar-overlay" [class.active]="isSidebarOpen" (click)="closeSidebar()"></div>

<aside class="course-sidebar" [class.open]="isSidebarOpen">
  <div class="sidebar-header-action">
    <button class="back-btn" (click)="backToCourseDetailPage()">
      <i class="bi bi-chevron-left"></i>
      <span>Back to Course</span>
    </button>
  </div>

  <div class="course-info-card" *ngIf="courseDetails">
    <h3 class="course-title">{{ courseDetails.course_title || "N/A" }}</h3>

    <div class="progress-container">
      <div class="progress-stats">
        <span class="progress-label">Course Progress</span>
        <span class="progress-value">{{ courseDetails.progress_percentage | number: "1.0-0" }}%</span>
      </div>
      <div class="progress-bar-bg">
        <div class="progress-bar-fill" [style.width.%]="courseDetails.progress_percentage"></div>
      </div>
      <p class="lessons-count" *ngIf="totalTopicsCount">
        {{ completedTopicsCount }} of {{ totalTopicsCount }} units completed
      </p>
    </div>
  </div>

  <div class="sidebar-nav-content" *ngIf="courseDetails">
    <div class="unit-section" *ngFor="let unit of courseDetails?.units; trackBy: trackByUnitId" [class.active-unit]="
        unit.unit_id.toString() === unitId ||
        (!unitId && courseDetails.units[0].unit_id === unit.unit_id)
      " [class.unit-completed]="isUnitCompleted(unit)">
      <div class="unit-header">
        <div class="unit-badge">{{ unit.order }}</div>
        <span class="unit-name">{{ unit.unit_title || "N/A" }}</span>
      </div>

      <ul class="topic-list">
        <li *ngFor="let topic of unit.topics" class="topic-item"
          [class.active-topic]="topic.topic_id.toString() === topicId" [class.topic-completed]="
            topic.status === StudentTopicProgressStatus.COMPLETED
          " (click)="
            navigateToLesson(unit.unit_id, topic.topic_id); closeSidebar()
          ">
          <div class="topic-status-icon">
            <i class="bi" [ngClass]="
                topic.status === StudentTopicProgressStatus.COMPLETED
                  ? 'bi-check-circle-fill'
                  : topic.topic_id.toString() === topicId
                    ? 'bi-play-circle-fill'
                    : 'bi-circle'
              "></i>
          </div>
          <span class="topic-title">{{ topic.topic_title || "N/A" }}</span>
        </li>
      </ul>
    </div>
  </div>
</aside>